import { useTexts } from '../hooks/useTexts'

export function getAlertConfig(
  percentage: number,
  lastRecurrenceSuccess: string | undefined,
  today: string,
  texts: ReturnType<typeof useTexts>,
  planType: 'operations' | 'none' | 'archived' | 'simulation',
) {
  if (percentage >= 100) {
    const showStorageFullWithDate = lastRecurrenceSuccess && lastRecurrenceSuccess > today
    const isOperations = planType === 'operations'

    return {
      severity: 'error' as const,
      title: texts.storageAlertErrorFullTitle,
      description: isOperations
        ? texts.storageAlertErrorFullDescription
        : texts.storageAlertErrorFullDescriptionSimulation,
      contentOne: isOperations ? texts.storageAlertErrorFullContentOne : null,
      contentTwoId: isOperations
        ? showStorageFullWithDate
          ? texts.storageAlertErrorFullContentTwoWithDateId
          : texts.storageAlertErrorFullContentTwoWithoutDateId
        : null,
    }
  }

  if (percentage >= 95) {
    return {
      severity: 'error' as const,
      title: texts.storageAlertErrorTitle,
      description: texts.storageAlertErrorDescription,
    }
  }

  if (percentage >= 80) {
    return {
      severity: 'warning' as const,
      title: texts.storageAlertWarningTitle,
      description: texts.storageAlertWarningDescription,
    }
  }
}
